<template>
  <div>
    <v-dialog v-model="recharge.dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Dodaj novac</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                {{recharge.user.name}}
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="recharge.transaction.value" label="Iznos"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="recharge.transaction.comment" label="Komentar"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="recharge.dialog=false">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="postRecharge()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <v-data-table
     :headers="headers"
     :items="users"
     hide-actions
     class="elevation-1"
     :loading="loading"
   >
     <template slot="items" slot-scope="props">
       <td>{{ props.item.id }}</td>
       <td>{{ formatDate(props.item.created) }}</td>
       <td>{{ formatDate(props.item.last_login) }}</td>
       <td>
         <v-edit-dialog :return-value.sync="props.item.name" lazy>
           {{ props.item.name }}
           <v-text-field slot="input" v-model="props.item.name" single-line></v-text-field>
         </v-edit-dialog>
       </td>
       <td>
         <v-edit-dialog :return-value.sync="props.item.roles" lazy>
           {{ props.item.roles }}
           <v-text-field slot="input" v-model="props.item.roles" single-line></v-text-field>
         </v-edit-dialog>
       </td>
       <td>{{ props.item.email }}</td>
       <td>
         <v-edit-dialog :return-value.sync="props.item.phone" lazy>
           {{ props.item.phone }}
           <v-text-field slot="input" v-model="props.item.phone" single-line></v-text-field>
         </v-edit-dialog>
       </td>
       <td>
         <v-edit-dialog :return-value.sync="props.item.address" lazy>
           {{ props.item.address }}
           <v-text-field slot="input" v-model="props.item.address" single-line></v-text-field>
         </v-edit-dialog>
       </td>
       <td>{{ props.item.balance }}</td>
       <td>
         <v-edit-dialog :return-value.sync="props.item.credit" lazy>
           {{ props.item.credit }}
           <v-text-field slot="input" v-model="props.item.credit" single-line></v-text-field>
         </v-edit-dialog>
       </td>
       <td>
         <v-edit-dialog :return-value.sync="props.item.exclusive_courier_id" lazy>
           {{ props.item.exclusive_courier_id }}
           <v-text-field slot="input" v-model="props.item.exclusive_courier_id" single-line></v-text-field>
         </v-edit-dialog>
       </td>
       <td>
         <v-edit-dialog :return-value.sync="props.item.proxy_id" lazy>
           {{ props.item.proxy_id }}
           <v-text-field slot="input" v-model="props.item.proxy_id" single-line></v-text-field>
         </v-edit-dialog>
       </td>
       <td class="justify-end layout px-0">
         <v-tooltip bottom>
           <v-btn v-if="props.item.android_registration" slot="activator" icon class="mx-0">
             <v-icon color="teal">android</v-icon>
           </v-btn>
           <span>Ima instaliranu aplikaciju</span>
         </v-tooltip>
         <v-btn v-if="!props.item.approved" icon class="mx-0" @click="approveUser(props.item)">
           <v-icon color="teal">check</v-icon>
         </v-btn>
         <v-btn icon class="mx-0" @click="saveUser(props.item)">
           <v-icon color="teal">save</v-icon>
         </v-btn>
         <v-btn icon class="mx-0" @click="showRechargeDialog(props.item)">
           <v-icon color="teal">euro_symbol</v-icon>
         </v-btn>
         <!-- <v-btn icon class="mx-0" @click="">
           <v-icon color="pink">delete</v-icon>
         </v-btn> -->
       </td>
     </template>
     <template slot="no-data">
       učitavanje...
     </template>
   </v-data-table>
 </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/sr'
import auth from '@/services/authService.js'
import userService from '@/services/userService'
export default {
  data () {
    return {
      headers: [
        { text: 'id', value: 'id' },
        { text: 'registrovan', value: 'created' },
        { text: 'poslednji login', value: 'last_login' },
        { text: 'ime', value: 'name' },
        { text: 'role', value: 'roles' },
        { text: 'email', value: 'email' },
        { text: 'telefon', value: 'phone' },
        { text: 'adresa', value: 'address' },
        { text: 'stanje računa', value: 'balance' },
        { text: 'dozvoljeni minus', value: 'credit' },
        { text: 'ekskluzivni kurir', value: 'exclusive_courier_id' },
        { text: 'agencija', value: 'proxy_id' },
        { text: '', value: 'actions' }
      ],
      users: userService.getUsers(),
      user: auth.getCurrentUser(),
      loading: false,
      recharge: {
        dialog: false,
        user: {},
        transaction: {}
      }
    }
  },
  methods: {
    formatDate (d) {
      return d ? moment(d).format('Do MMMM YYYY, h:mm:ss') : ''
    },
    approveUser (user) {
      user.approved = true
      this.saveUser(user)
    },
    saveUser (user) {
      this.loading = true
      userService.updateUser(user).then(() => { this.loading = false })
    },
    showRechargeDialog (user) {
      this.recharge.user = Object.assign(this.recharge.user, user)
      this.recharge.dialog = true
    },
    postRecharge () {
      this.loading = true
      userService.recharge(this.recharge.user.id, this.recharge.transaction).then(() => {
        this.users = userService.getUsers()
        this.loading = false
        this.recharge.dialog = false
      })
    }
  }
}
</script>

<style scoped>
</style>
